<!-- 
 * @Descripttion: 
 * @Author: sjq
 * @Date: 2023-07-28 17:37:34
 * @LastEditors: sjq
 * @LastEditTime: 2023-07-31 09:28:04
 -->
<template>
  <div
    class="minheight100"
    style="padding-bottom: 130px"
    :class="{ 'bg-grey': dataDetail && dataDetail.activityStatus > 1 }"
  >
    <app-header v-if="appUser.isNative" back-type="back-app" :title="title"></app-header>
    <template v-if="dataDetail">
      <div class="nocon" v-if="dataDetail.activityStatus === 3">
        <img src="./images/close_status.png" />
        <p>活动已关闭</p>
      </div>
      <div class="imgmax" style="text-align: center" v-else>
        <!-- activityRuleDesc -->
        <div class="fixed-right-main" :style="{ top: nativeHeaderHeight + 80 + 'px' }">
          <div class="explain font14" @click="goActivity" v-if="dataDetail.applyActivityUrl && !isGiftCard">
            上传截图
          </div>
          <div
            v-if="dataDetail.showRuleDesc === 1"
            class="explain font14"
            style="margin-top: 20px"
            @click="explainShow = true"
          >
            活动规则
          </div>
        </div>

        <div v-html="dataDetail.activityContent"></div>
      </div>
    </template>
    <div class="fixed-bottom" v-if="dataDetail && dataDetail.activityStatus !== 3">
      <div class="fixed-bottom-flex" v-if="isGiftCard">
        <div class="btn-common" style="padding: 15px 0 15px; font-weight: bold" @click="joinGiftCard">
          <template v-if="dataDetail.process">查看进度</template>
          <template v-else>参与活动领取{{ dataDetail.giftCardNum }}张礼品卡</template>
        </div>
      </div>
      <template v-else>
        <div class="btn-common" @click="generatePoster">生成我的海报</div>
        <div class="txt-center color-green" style="padding: 15px 0 10px; font-weight: bold" @click="progressClick">
          查看进度
        </div>
      </template>
    </div>
    <div class="dialog-mask" v-if="dialogShow">
      <div class="my-swiper" v-if="qrImgpath">
        <swiper :options="swiperOption" ref="mySwiper" class="swiper">
          <swiper-slide v-for="(item, index) in dataShareDetail.canvasObj" :key="index" class="swiper_item">
            <div :id="'capture' + index" style="height: 100%" v-if="item.picUrl && qrImgpath">
              <img
                v-if="item.isGenerate === true"
                style="position: absolute; z-index: 100; top: 0; left: 0; opacity: 0"
                class="cover"
                crossorigin="anonymous"
                :src="item.canvasUrl"
                alt=""
              />

              <img :src="item.picUrl" @load="onImageLoad(index)" crossorigin="anonymous" />
              <div class="qrcode" v-if="qrImgpath">
                <img :src="qrImgpath" />
              </div>
            </div>
          </swiper-slide>

          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <div class="longpress">长按并保存图片，分享至朋友圈</div>
        <div class="dialog-close bottom" style="bottom: -80px; opacity: 0.8" @click="dialogShow = false">×</div>
      </div>
    </div>
    <div class="dialog-mask" v-if="explainShow" @click.stop="explainShow = false">
      <div class="explain-con" @click.stop="">
        <div class="title">活动规则</div>
        <div class="container">
          <div class="myrule" v-html="dataDetail.activityRuleDesc"></div>
        </div>
        <div class="know">
          <div class="btn-common" @click="explainShow = false">我知道了</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Body from '@/mixins/body'
import { mapGetters } from 'vuex'

import html2canvas from 'html2canvas'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import { activityService } from '@/api'
import QRCode from 'qrcode'
import { toLoginView } from '@/utils/init/env-init'
import { Toast, Dialog } from 'vant'
import { appUser } from '@/utils'
import { saTrack } from '@/utils/common/shence'
import { resolve } from 'path'

const action = 'activityIndex'

export default {
  name: '',
  components: {
    swiper: swiper,
    swiperSlide: swiperSlide,
    'van-dialog': Dialog.Component
  },
  data() {
    return {
      appUser,
      title: '',
      shareUserId: appUser.userId,
      dialogShow: false,
      explainShow: false,
      shareLoading: false,
      dataDetail: null,
      pageName: '',
      isGiftCard: false,
      dataShareDetail: null,
      qrImgpath: '',
      canvasUrl: '',
      swiperOption: {
        effect: 'coverflow',
        centeredSlides: true,
        spaceBetween: 10,
        slidesPerView: 'auto',
        loop: false,
        autoplay: false, // 是否自动播放
        touchRatio: 2,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false
        },

        on: {
          slideChangeTransitionEnd: res => {
            //监听滑动
          }
        }
        // pagination: {
        //   el: '.swiper-pagination',
        //   type: 'fraction'
        // },
      },
      nativeHeaderHeight: parseInt(appUser.appStatusBarHeight || 0) + 44
    }
  },
  mixins: [Body],
  computed: {
    ...mapGetters('args', ['shareCode'])
  },
  async created() {
    this.pageName = this.$route.name
    this.isGiftCard = this.pageName === 'giftCardActivity'
    console.log('进来活动created了')
    //https://new-wx.ylyk.com/test/ylyk/payment.html#/activity?shareCode=15
    this.shareUserId = appUser.userId
    console.log(appUser.userId)
    // 如果没有登录，先去登录
    if (!this.hasUser()) {
      return
    }
    this.getData()
  },
  mounted() {},
  methods: {
    // 检查用户
    hasUser() {
      // 无token去登录
      if (!this.hasToken({ action })) {
        toLoginView({ type: 'button', action })
        return false
      }
      return true
    },
    // 微信登录后，再次获取用户数据
    getWXUserAfter_getData() {
      console.log('进微信登录了')
      console.log(appUser.userId)
      this.shareUserId = appUser.userId
      setTimeout(() => {
        this.getData()
      })
    },
    // enterAfterLogin(wxAfterInfo) {
    //   return this.$store.dispatch('user/login/enterAfterLogin', { action }).then(action => {
    //     console.log(appUser.userId)
    //     return action
    //   })
    // },
    //活动概览
    async getData() {
      const apiMethod = this.isGiftCard ? activityService.giftCardActivityDetail : activityService.activityDetail
      return new Promise((reslove, reject) => {
        apiMethod
          .call(activityService, {
            shareCode: this.shareCode
          })
          .then(res => {
            this.dataDetail = res
            if (res) this.title = this.dataDetail.activityName
            saTrack(
              'autoTrack',
              {
                web_type: this.isGiftCard ? '礼品卡转介绍' : '转介绍',
                web_name: '活动首页',
                activity_id: this.dataDetail.activityId,
                inviter_id: appUser.userId,
                salesman_id: this.dataDetail.adminShareUserId
              },
              'quick'
            )

            resolve()
          })
      })
    },

    // 设置分享数据
    setShareData() {
      if (this.dataDetail && this.dataDetail.shareMainTitle) {
        return {
          title: this.dataDetail.shareMainTitle,
          desc: this.dataDetail.shareSecondTitle,
          link: location.href,
          imgUrl: this.dataDetail.shareImg
        }
      }
    },
    //生成海报
    generatePoster() {
      if (!this.checkStatus()) return

      if (this.dataDetail.activityStatus === 2) {
        this.$toast('活动已结束！')
        return
      }
      if (this.dataDetail.showShareImgUrl !== 1) {
        this.$router.push({
          name: 'activityRecommend',
          query: { activityId: this.dataDetail.activityId }
        })
        return
      }

      this.$router.push({ path: 'activity_poster', query: this.$route.query })
    },
    progressClick() {
      if (!this.checkStatus()) return
      this.$router.push({
        path: 'activity_progress',
        query: { activityId: this.dataDetail.activityId, shareUserId: this.shareUserId }
      })
    },
    checkStatus() {
      if (!this.dataDetail || this.dataDetail.activityStatus === 0) {
        this.$toast('活动未开始！')
        return false
      }
      return true
    },
    goActivity() {
      location.href = this.dataDetail.applyActivityUrl
    },
    joinGiftCard() {
      const activityId = this.dataDetail.activityId
      if (this.dataDetail.process) {
        this.$router.push({ path: '/giftCardProgress', query: { activityId } })
        return
      }
      activityService
        .giftCardJoin({
          shareCode: this.shareCode,
          activityId
        })
        .then(() => {
          this.$router.push({ path: '/giftCardProgress', query: { activityId } })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'index.scss';
.longpress {
  position: absolute;
  text-align: center;
  left: 0;
  right: 0;
  bottom: -30px;
  font-size: 16px;
  color: #fff;
}
.my-swiper {
  position: absolute;
  width: 100vw;
  height: 135vw;
  top: 50%;
  margin-top: -75vw;
}
.swiper-container {
  position: absolute;
  width: 100%;
  top: 0;
  bottom: 0;
  overflow: visible !important;
  .swiper-wrapper .swiper-slide {
    width: 81vw;
    border-radius: 8px;
    overflow: hidden;
    transform: none !important;
    height: 125vw;
    margin-top: 5vw;
  }
  .swiper-slide-active {
    height: 100% !important;
    margin-top: 0 !important;
  }
  .swiper-wrapper .swiper-slide img {
    width: 100%;
    height: 100%;
  }
  .swiper-pagination {
    font-size: 28px;
    color: #8a91a4;
    bottom: -80px !important;
  }
}
.qrcode {
  position: absolute;
  bottom: 16px;
  right: 16px;
  padding: 5px;
  border-radius: 4px;
  border: 1px solid #000;
  width: 80px;
  height: 80px;
  background-color: #fff;
}
.fixed-right-main {
  position: fixed;
  top: 80px;
  right: 0;
}
.explain {
  background: rgba(0, 0, 0, 0.6);
  border-top-left-radius: 24px;
  border-bottom-left-radius: 24px;
  padding: 8px 10px 8px 16px;
  color: #fff;
}

.fixed-bottom-flex {
  display: flex;
  .btn-common {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
    img {
      height: 8px;
      margin-left: 4px;
    }
    &:last-child {
      margin-right: 0px;
      margin-left: 8px;
    }
  }
}

.explain-con {
  border: 5px solid #366c6d;
  border-radius: 8px;
  position: relative;
  height: 80vh;
  margin: 0 20px;
  margin-top: 15vh;
  background: #fff;
  padding: 45px 0px 76px;
  .title {
    position: absolute;
    top: -9px;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 120px;
    height: 50px;
    line-height: 42px;
    text-align: center;
    background: url('./images/rule_title_bg.png') no-repeat;
    background-size: 100% auto;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
  }
  .container {
    padding: 0 20px;
    line-height: 22px;
    height: 100%;
    overflow-y: auto;
  }
  .myrule {
    h3 {
      margin-top: 16px;
      margin-bottom: 5px;
      font-size: 16px;
    }
    p {
      font-size: 14px;
      color: #555;
    }
  }
  .know {
    position: absolute;
    background-color: #fff;
    bottom: 0;
    width: 100%;
    padding: 16px;
  }
}
</style>
